import React, { useContext, useEffect, useMemo } from 'react';
import { modifyData } from '../Utils/cartPageUtils';
import {
  createPayloadForStatusCall,
  getClosestScreenWidth,
  isEmptyEvery,
  ParseJsonSafely,
} from 'common/utilities/utils';
import CartPageItems from '../Presentation/CartPageItems';
import EmptyCartItems from '../Presentation/EmptyCartItems';
import { SET_COUPON_ERROR_MESSAGE, COUPON_STATIC_MSG } from 'organisms/CouponsLanding/Constants/CouponConstants';
import { UserOrderContext } from 'context/context';
import { useDispatch } from 'react-redux';
import { getStoreStatusForTimeSaga } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { setPriceLimitInLocalStorage } from 'organisms/CartPage/AU/Utils/cartPageUtils';

const CartPageComponent = props => {
  const {
    contentData = {},
    cartListContent,
    isModalOpen,
    confirmChangesHandler,
    dispositionData,
    isModelClosed,
    isMobile,
    pdpbackgroundImageData,
    isShowCreateOrderError,
  } = props;
  const { cartReducer, tenantReducer, segmentedHelpData } = contentData;
  const bucketSize = getClosestScreenWidth(window.innerWidth);
  let cartListData = {};
  if (cartReducer?.cartData && cartListContent.length) {
    cartListData = modifyData(
      cartReducer.cartData,
      cartListContent,
      tenantReducer?.tenantId,
      tenantReducer?.currencyConversionFactor,
      tenantReducer?.addHope,
      tenantReducer?.carryBag,
      bucketSize,
      tenantReducer?.country,
      isMobile,
      pdpbackgroundImageData,
      cartReducer.isRemoveItemLoading,
      tenantReducer?.componentOptions?.web?.cartPage?.showTaxLines,
    );
  }
  const dispatch = useDispatch();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { CURRENT_STORE_INFO_STORAGE, DISPOSITION_TYPE } = LOCAL_STORAGE_KEYS;
  const { componentOptions: { web: { shouldCheckDropOffAddress = false } = {} } = {} } = tenantReducer ?? {};

  const currentStoreInfoData = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem(CURRENT_STORE_INFO_STORAGE))
      : userOrderState.currentStoreInfo;
  }, [CURRENT_STORE_INFO_STORAGE, userOrderState.currentStoreInfo]);

  const { dispositionType } = userOrderState.dispositionStateData;

  useEffect(() => {
    const serviceType = dispositionType
      ? dispositionType?.toLowerCase()
      : localStorage.getItem(DISPOSITION_TYPE)?.toLowerCase();
    const dataList = createPayloadForStatusCall([currentStoreInfoData], serviceType, null, shouldCheckDropOffAddress);
    const userTimeSlot = cartReducer?.cartData?.requestedDateTime?.futureDateTime ?? '';
    const payload = {
      storeid: dataList[0]?.storeId,
      service: dataList[0].service,
      channel: dataList[0].channel,
    };
    const finalPayload = userTimeSlot ? { ...payload, futureDateTimeInEpochFormat: userTimeSlot } : payload;
    dispatch(
      getStoreStatusForTimeSaga(
        { data: finalPayload, tenantId: tenantReducer?.tenantId },
        response => {
          setPriceLimitInLocalStorage(response?.[0]?.summary?.menu);
        },
        null,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.history?.location?.pathname]);

  useEffect(() => {
    if (cartReducer?.cartData?.discountLines?.length === 0) {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: '' },
      });
      localStorage.removeItem('expiryMessage');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartListData?.cartSummary?.quantity]);

  useEffect(() => {
    if (cartListData?.cartSummary?.discountAmounts[0]?.isError) {
      userOrderStateDispatch({
        type: SET_COUPON_ERROR_MESSAGE,
        value: { couponErrorMessage: COUPON_STATIC_MSG + cartListData?.cartSummary?.discountAmounts[0]?.errorMessages },
      });
      localStorage.removeItem('expiryMessage');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartListData?.cartSummary?.discountAmounts?.[0]?.isError]);

  return cartListData.cartList ? (
    <CartPageItems
      contentData={cartListData}
      isModalOpen={isModalOpen}
      currencySymbol={tenantReducer.currencySymbol}
      currencyConversionFactor={tenantReducer.currencyConversionFactor}
      addHope={tenantReducer.addHope}
      carryBag={tenantReducer.carryBag}
      confirmChangesHandler={confirmChangesHandler}
      faqAndContactData={segmentedHelpData}
      tenantId={tenantReducer?.tenantId}
      maxItemCountPerLineItem={tenantReducer?.maxItemCountPerLineItem}
      dispositionData={dispositionData}
      history={props.history}
      isModelClosed={isModelClosed}
      isShowCreateOrderError={isShowCreateOrderError}
      isRemoveItemLoading={cartReducer.isRemoveItemLoading}
    />
  ) : (
    <EmptyCartItems
      contentData={cartListData}
      faqAndContactData={segmentedHelpData}
      history={props.history}
      dispositionData={dispositionData}
    />
  );
};

export default CartPageComponent;
